var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 1C19.451 1 15.0042 2.34893 11.2219 4.8762C7.43956 7.40347 4.4916 10.9956 2.75078 15.1983C1.00997 19.401 0.554489 24.0255 1.44195 28.4871C2.32941 32.9486 4.51995 37.0468 7.73655 40.2635C10.9532 43.4801 15.0514 45.6706 19.5129 46.5581C23.9745 47.4455 28.599 46.99 32.8017 45.2492C37.0044 43.5084 40.5965 40.5604 43.1238 36.7781C45.6511 32.9958 47 28.549 47 24C46.9931 17.9021 44.5677 12.056 40.2559 7.74414C35.944 3.4323 30.0979 1.00688 24 1V1ZM24 38C23.6044 38 23.2178 37.8827 22.8889 37.6629C22.56 37.4432 22.3036 37.1308 22.1523 36.7654C22.0009 36.3999 21.9613 35.9978 22.0384 35.6098C22.1156 35.2219 22.3061 34.8655 22.5858 34.5858C22.8655 34.3061 23.2219 34.1156 23.6098 34.0384C23.9978 33.9613 24.3999 34.0009 24.7654 34.1522C25.1308 34.3036 25.4432 34.56 25.6629 34.8889C25.8827 35.2178 26 35.6044 26 36C26 36.5304 25.7893 37.0391 25.4142 37.4142C25.0391 37.7893 24.5304 38 24 38ZM25.045 30.171H22.994L22 9.487H26.043L25.045 30.171Z",
    fill: "#c53939"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.2233eb7b.svg";
export { ForwardRef as ReactComponent };